import _ from 'lodash'
const SLIDER_HOME_BUSINESS_CONFIG = {
    section: _.select( '.c-section--home-business' ),
    slider: _.select( '.c-section--home-business .slider' ),
    slides: _.selectAll( '.c-section--home-business .slider .slides' ),
    navs: _.selectAll( '.c-section--home-business .nav button' ),
    bars: _.selectAll( '.c-section--home-business .nav button span' ),
    autoPlay: 5000
}

export default SLIDER_HOME_BUSINESS_CONFIG